const showMore = (el) => {

  const $el = $(el);
  const totItems = $el.data('count');
  let counter = 0;

  const showMoreList = $el.prev($('.js-show-more-list'));
  const hiddenItems = showMoreList.find($('.js-hidden'));

    $el.on('click', (e) => {
      counter++;

      if(counter == totItems) {
        $el.attr('disabled', true);
      }
    });
};



export default showMore;
